import script from "./SlideThumbnails.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideThumbnails.vue?vue&type=script&lang=ts&setup=true"

import "./SlideThumbnails.vue?vue&type=style&index=0&id=b7c6c0cc&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7c6c0cc"]])

export default __exports__